<template>
  <nav class="navbar pl-4 pr-4 pt-4">
    <span>{{ username }}</span>
    <ul class="navbar-nav d-none flex-row ml-auto d-md-flex align-items-center justify-content-end">
      <li class="mr-2">
        <!--                <b-badge variant="warning">SMS Kredisi: <b>{{ smsBalance }}</b></b-badge>-->
        <b-dropdown>
          <template #button-content>
            <flag :iso="currentFlag"></flag>
          </template>
          <b-dropdown-item @click="changeLanguage(lang.val)" v-for="lang in languages" v-bind:key="lang.val">
            <div class="text-center" style="font-size:30px">
              <flag :iso="lang.flag"></flag>
            </div>

          </b-dropdown-item>
        </b-dropdown>
      </li>
      <li>
<!--                <b-badge variant="warning">SMS Kredisi: <b>{{ smsBalance }}</b></b-badge>-->
        <b-dropdown>
          <template #button-content>
            <i :class="'ni ni-bell-55 '+ (announces.length>0 ?  'text-danger' : '')" ></i>
            <b-badge v-if="announces.length>0" variant="warning"> {{ announces.length}}</b-badge>
          </template>
          <b-dropdown-item @click="currentAnnounce=announce; $refs.announceModal.show(); " v-for="announce in announces" v-bind:key="announce.id">{{ announce.title}}</b-dropdown-item>
        </b-dropdown>
      </li>
      <li class="ml-4">
        <a href="http://kusaksoft.com" target="_blank" title="Destek"><i class="ni ni-support-16"></i></a>
      </li>
      <li class="ml-4">
        <router-link :to="{name: 'settings'}" title="Ayarlar"><i class="ni ni-settings"></i></router-link>
      </li>
      <li class="ml-4" @click="logoutAction">
        <a href="#" title="Çıkış Yap"><i class="ni ni-user-run"></i></a>
      </li>
    </ul>
    <b-modal :title="currentAnnounce.title" ref="announceModal">
      <p v-html="currentAnnounce.description"></p>
      <p class="text-right">
        {{ currentAnnounce.created_at}}
      </p>

      <template v-slot:modal-footer>
        <b-button @click="$refs.announceModal.hide()">Kapat</b-button>
      </template>
    </b-modal>


  </nav>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import language from '../languages/index'

export default {
  data() {
    return {
      languages:[{
        label:"Türkçe",
        val:"tr",
        flag:'tr'
      },{
        label:"Almanca",
        val:"ger",
        flag:'de'
      }],
      announces:[],
      currentAnnounce:{},
      activeNotifications: false,
      showMenu: false,
      searchQuery: ''
    };
  },
  mounted(){
    this.getAnnounces().then(res=>this.announces=res.data);
  },
  computed: {
    ...mapGetters(['user', 'smsBalance','announcesGetter']),
    currentFlag(){
      return this.languages.find(lang=>lang.val==language.language).flag
      // return
    },
    expirationDate() {
      return this.user ? moment(this.user.company.expiration_date).format('DD.MM.YYYY') : ''
    },
    logoUrl() {
      return this.user && this.user.company.logo_url ? this.user.company.logo_url : ''
    },
    username() {
      return this.user ? this.user.name : ''
    },
  },
  methods: {
    ...mapActions(['logout','getAnnounces']),

    changeLanguage(val){
      localStorage.setItem('lang',val)
      location.reload()
    },
    logoutAction() {
      this.logout().then(() => {
        this.$router.go({name: 'login'});
      })
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>
